export const user = {
  name: "Ana",
  profile: "Estratega Analítico",
  temperament: "Melancólico",
  streakDays: 7,
  routeProgress: 25,
  coursesProgress: 35,
  masterclassProgress: 0,
  completedModules: 2,
  totalModules: 8,
};

export const quickAccess = [
  { key: "ruta", label: "Mi Ruta", icon: "ri-route-line", to: "/app/mi-ruta", color: "accent" },
  { key: "cursos", label: "Cursos", icon: "ri-graduation-cap-line", to: "/app/cursos", color: "primary" },
  { key: "reuniones", label: "Reuniones", icon: "ri-calendar-line", to: "/app/reuniones", color: "secondary" },
  { key: "guia", label: "Guía IA", icon: "ri-robot-2-line", to: "/app/guia-ia", color: "accent" },
  { key: "masterclass", label: "Masterclass", icon: "ri-play-circle-line", to: "/app/cursos", color: "primary" },
  { key: "perfil", label: "Mi Perfil", icon: "ri-user-3-line", to: "/app/perfil", color: "secondary" },
];

export const activity = [
  {
    id: 1,
    icon: "ri-book-open-line",
    color: "primary",
    title: "Lección: Mentalidad de crecimiento",
    subtitle: "Curso de Crecimiento Personal",
    status: "done",
  },
  {
    id: 2,
    icon: "ri-play-circle-line",
    color: "accent",
    title: "Masterclass para tu perfil",
    subtitle: "Visto 60%",
    progress: 60,
    status: "progress",
  },
  {
    id: 3,
    icon: "ri-calendar-event-line",
    color: "secondary",
    title: "Reunión: Orientación para invitados",
    subtitle: "Mañana, 8:00 PM",
    status: "upcoming",
  },
];

export const modules = [
  {
    id: 1,
    number: "MÓDULO 1",
    title: "Descubre tu perfil",
    description: "Conócete a profundidad y entiende tu potencial.",
    icon: "ri-map-pin-line",
    accent: "primary",
    progress: 100,
    status: "completed",
  },
  {
    id: 2,
    number: "MÓDULO 2",
    title: "Crecimiento personal",
    description: "Desarrolla tu mentalidad y hábitos ganadores.",
    icon: "ri-line-chart-line",
    accent: "primary",
    progress: 60,
    status: "progress",
  },
  {
    id: 3,
    number: "MÓDULO 3",
    title: "Finanzas personales",
    description: "Aprende a administrar, invertir y multiplicar tu dinero.",
    icon: "ri-money-dollar-circle-line",
    accent: "accent",
    progress: 0,
    status: "next",
  },
  {
    id: 4,
    number: "MÓDULO 4",
    title: "Oratoria efectiva",
    description: "Comunica tus ideas con seguridad e impacto.",
    icon: "ri-mic-line",
    accent: "accent",
    progress: 0,
    status: "locked",
  },
  {
    id: 5,
    number: "MÓDULO 5",
    title: "Modelos de negocio",
    description: "Descubre oportunidades y crea negocios sostenibles.",
    icon: "ri-rocket-line",
    accent: "secondary",
    progress: 0,
    status: "locked",
  },
  {
    id: 6,
    number: "MÓDULO 6",
    title: "Inteligencia Artificial",
    description: "Aplica la IA para potenciar tu productividad y tu negocio.",
    icon: "ri-robot-2-line",
    accent: "accent",
    progress: 0,
    status: "locked",
  },
  {
    id: 7,
    number: "MÓDULO 7",
    title: "Masterclass personalizada",
    description: "Estrategias específicas para tu perfil y tus objetivos.",
    icon: "ri-tv-2-line",
    accent: "primary",
    progress: 0,
    status: "locked",
  },
  {
    id: 8,
    number: "MÓDULO 8",
    title: "Liderazgo y comunidad",
    description: "Lidera tu vida y transforma la de otros.",
    icon: "ri-group-line",
    accent: "secondary",
    progress: 0,
    status: "locked",
  },
];

export const courses = [
  {
    id: "c1",
    ghlOfferUrl: "https://app.vivelo-ai.com/courses/offers/9e81ebb2-3bf9-418f-82fb-a66e7d911e36",
    title: "Crecimiento personal",
    description: "Desarrolla mentalidad, hábitos y disciplina para alcanzar tu mejor versión.",
    icon: "ri-plant-line",
    tag: "Recomendado",
    tagColor: "primary",
    lessons: 6,
    minutes: 35,
    level: "Básico",
    progress: 60,
    cta: "Continuar",
    ctaColor: "primary",
  },
  {
    id: "c2",
    ghlOfferUrl: "https://app.vivelo-ai.com/courses/offers/e6b8fb5a-3d2c-48fc-8c32-2a67b791c0f8",
    title: "Finanzas personales",
    description: "Aprende a administrar, invertir y multiplicar tu dinero.",
    icon: "ri-money-dollar-circle-line",
    tag: "Muy recomendado",
    tagColor: "secondary",
    lessons: 5,
    minutes: 28,
    level: "Básico",
    progress: 20,
    cta: "Continuar",
    ctaColor: "secondary",
  },
  {
    id: "c3",
    ghlOfferUrl: "https://app.vivelo-ai.com/courses/offers/2c7d39ba-9775-4a07-8cbc-d88fffe53485",
    title: "Oratoria efectiva",
    description: "Comunica tus ideas con seguridad e impacto en cualquier situación.",
    icon: "ri-mic-line",
    tag: "Recomendado",
    tagColor: "primary",
    lessons: 4,
    minutes: 25,
    level: "Intermedio",
    progress: 10,
    cta: "Continuar",
    ctaColor: "accent",
  },
  {
    id: "c4",
    ghlOfferUrl: "https://app.vivelo-ai.com/courses/offers/24f149b9-7a00-49cb-9351-8af25c9f1ab8",
    title: "Modelos de negocio",
    description: "Descubre oportunidades y crea negocios sostenibles.",
    icon: "ri-rocket-line",
    tag: "Próximo para ti",
    tagColor: "warning",
    lessons: 6,
    minutes: 45,
    level: "Intermedio",
    progress: 0,
    cta: "Ver curso",
    ctaColor: "outline-warning",
  },
  {
    id: "c5",
    ghlOfferUrl: "https://app.vivelo-ai.com/courses/offers/20914dc0-fb3d-40d7-9e55-ef4dee6213ca",
    title: "Inteligencia Artificial",
    description: "Aplica la IA en tu día a día para ser más productivo y creativo.",
    icon: "ri-robot-2-line",
    tag: "Nuevo para ti",
    tagColor: "primary",
    lessons: 5,
    minutes: 30,
    level: "Básico",
    progress: 0,
    cta: "Ver curso",
    ctaColor: "outline-primary",
  },
  {
    id: "c6",
    ghlOfferUrl: "https://app.vivelo-ai.com/courses/offers/416844f4-4337-4a56-a1ee-3b5ec8d8d23e",
    title: "Liderazgo y comunidad",
    description: "Lidera tu vida, inspira a otros y genera un impacto positivo.",
    icon: "ri-group-line",
    tag: "Comunidad",
    tagColor: "primary",
    lessons: 4,
    minutes: 20,
    level: "Todos los niveles",
    progress: 0,
    cta: "Ver curso",
    ctaColor: "outline-primary",
  },
];

export const strengths = [
  "Ves detalles que otros no ven",
  "Analizas y tomas decisiones inteligentes",
  "Organizado(a) y enfocado(a)",
  "Buscas la excelencia y la calidad",
  "Piensas antes de actuar",
];

export const challenges = [
  "Evitar quedarte pensando demasiado",
  "Confiar más en tu intuición",
  'Tomar acción sin esperar "el momento perfecto"',
  "Delegar y soltar el control",
  "Comunicar tus ideas con más confianza",
];

export const routeSteps = [
  { n: 1, title: "Descubre", subtitle: "Tu perfil", icon: "ri-map-pin-line", accent: "primary" },
  { n: 2, title: "Crece", subtitle: "Personalmente", icon: "ri-plant-line", accent: "primary" },
  { n: 3, title: "Mejora", subtitle: "Tus finanzas", icon: "ri-money-dollar-circle-line", accent: "secondary" },
  { n: 4, title: "Comunica", subtitle: "Con impacto", icon: "ri-mic-line", accent: "accent" },
  { n: 5, title: "Emprende", subtitle: "Con propósito", icon: "ri-rocket-line", accent: "accent" },
  { n: 6, title: "Lidera", subtitle: "Y transforma", icon: "ri-star-line", accent: "primary" },
];

export const upcomingMeetings = [
  {
    id: "m1",
    title: "Orientación para invitados",
    host: "Coach Laura Restrepo",
    when: "Mañana · 8:00 PM",
    duration: "60 min",
    type: "En vivo",
    icon: "ri-live-line",
  },
  {
    id: "m2",
    title: "Masterclass: Estrategia Analítica",
    host: "Coach Andrés Molina",
    when: "Vie 15 · 7:00 PM",
    duration: "75 min",
    type: "Masterclass",
    icon: "ri-tv-2-line",
  },
  {
    id: "m3",
    title: "Sesión Q&A sobre finanzas",
    host: "Coach Camila Herrera",
    when: "Sáb 16 · 10:00 AM",
    duration: "45 min",
    type: "Comunidad",
    icon: "ri-question-answer-line",
  },
];

export const guideSuggestions = [
  "Ayúdame a prospectar para hoy",
  "Genera un opener para un prospecto",
  "¿A quién debo dar seguimiento?",
  "Recomiéndame un curso para mi perfil",
  "Entréname en ventas por mensaje",
  "Coaching para cerrar una reunión",
];